// @flow

import React from 'react';

type Props = {
  name: string,
  component?: any
};

export default ({ name, component: Wrapper = 'div', ...restProps }: Props) => (
  <Wrapper name={name} {...restProps} />
);
